/**
 * Pair & Save invitation opt-out
 * The link at the bottom of the invitation email. No guard and no sign-in: the person may
 * have no account. It asks before acting, because mail scanners open links by themselves.
 */

import React, { useState } from 'react'
import { createFileRoute, useSearch } from '@tanstack/react-router'
import { AuthButton, AuthNote, AuthShell } from '../components/auth/AuthShell'
import { billingService } from '../services/billing.service'

interface SearchParams {
  token?: string
}

export const InviteOptOutRouteComponent: React.FC = () => {
  const { token } = useSearch({ from: '/invite-opt-out' }) as SearchParams
  const [status, setStatus] = useState<'asking' | 'working' | 'done' | 'failed'>(token ? 'asking' : 'failed')

  const stop = async () => {
    setStatus('working')
    try {
      await billingService.optOutOfPairInvites(token!)
      setStatus('done')
    } catch {
      setStatus('failed')
    }
  }

  if (status === 'done') {
    return <AuthShell title="You won't get these again" subtitle="We won't send this address any more Pair & Save invitations." />
  }

  if (status === 'failed') {
    return (
      <AuthShell title="This link didn't work">
        <AuthNote>Please email info@charti.ai and we'll stop these invitations for you.</AuthNote>
      </AuthShell>
    )
  }

  return (
    <AuthShell
      title="Stop these invitations?"
      subtitle="A colleague named this address as their Pair & Save partner on Charti. If you'd rather not hear about it, we won't send it any more invitations.">
      <AuthButton busy={status === 'working'} onClick={stop}>
        Stop invitations
      </AuthButton>
    </AuthShell>
  )
}

export const Route = createFileRoute('/invite-opt-out')({
  component: InviteOptOutRouteComponent,
})
